import { joinSearchParams } from '@modules/common/utils';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { AnalysisViewFragment } from 'generated/graphql';
import { isEqual } from 'lodash';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { getHasGlobalFilterDurationChangedFromDefault } from '../helpers';
import { useGenerateGlobalFilterSearchParamsFromStore } from './useGenerateGlobalFilterSearchParamsFromStore';

interface UseGetDashboardSearchParamsForAnalysisOptions {
  analysis: AnalysisViewFragment;
  additionalParams?: Record<string, string>;
}

export const useGetDashboardSearchParamsForAnalysis = ({
  analysis,
  additionalParams = {},
}: UseGetDashboardSearchParamsForAnalysisOptions) => {
  const globalFilterDuration = useDashboardStore(({ query }) => query.duration);
  const globalFilterWhereClause = useDashboardStore(
    ({ query }) => query.whereClause,
  );

  const hasGlobalFilterDurationChangedFromDefault =
    getHasGlobalFilterDurationChangedFromDefault(globalFilterDuration);

  const hasGlobalFilterWhereClauseChanged = !isEqual(
    globalFilterWhereClause,
    EmptyWhereClause,
  );

  const shouldAddGlobalFilterParam =
    hasGlobalFilterDurationChangedFromDefault ||
    hasGlobalFilterWhereClauseChanged;

  const globalFilterSearchParamString =
    useGenerateGlobalFilterSearchParamsFromStore();

  const additionalParamString = joinSearchParams({
    ...additionalParams,
    showGlobalFilters: JSON.stringify(shouldAddGlobalFilterParam),
  });

  return `${globalFilterSearchParamString}&${additionalParamString}`;
};
